import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns the previous day relative to the current time in the given timezone.
 *
 * This helper is specifically designed to handle cron jobs that run shortly after midnight.
 * By using the provided timezone, it avoids issues where the system clock (often UTC)
 * might be on a different calendar day than the intended local timezone.
 *
 * @param tz Timezone identifier (default: "Europe/Warsaw")
 * @returns dayjs instance representing the previous day in that timezone
 */
export const getPreviousDayInTimezone = (tz = "Europe/Warsaw") => {
  return dayjs().tz(tz).subtract(1, "day");
};
